<template>
  <div
    id="sponsored-item-top-container"
    ref="sponsoredItemTopRef"
  >
    <ProductThumbnail
      v-if="sponsoredItemTop"
      :product="sponsoredItemTop.product"
      alignment="horizontal"
      :wrap-product-name="true"
      draggable="false"
      :image-width="100"
      :hide-review-text-and-rating="true"
      :open-in-new-tab="isOpenInNewTabEnabled"
      :is-simplification-on="isSimplificationOnEnabled"
      :simplification-with-v1="simplificationWithV1"
      :simplification-non-bold-percentage-exp="simplificationNonBoldPercentageExp"
      :simplification-remove-sale-exp="simplificationRemoveSaleExp"
      :override-price-simplification="overridePriceSimplification"
      @click-once="analyticsUtil.sponsoredItemTopClickEvent(productSMData?.onClickBeacon, enableClickTagsForSMProducts)"
    />
  </div>
</template>

<script setup>
import {
  watch, computed, ref, onMounted,
} from 'vue';
import { useStore } from 'vuex';
import { ProductThumbnail } from '@common-vue/product-thumbnail';
import transformer from '@common-vue/product-carousel/src/utils/Interface';
import analyticsUtil from '../utils/analyticsUtil';
import {
  isSimplificationOnExperimentEnabled, isSimplificationWithV1ExpEnabled,
  isSimplificationNonBoldPercentageExpEnabled, isSimplificationRemoveSaleExpEnabled,
} from '../utils/experimentUtil';

const props = defineProps({
  enableClickTagsForSMProducts: {
    type: Boolean,
    required: true,
    default: false,
  },
  isSimplificationOn: {
    type: Boolean,
    required: false,
    default: false,
  },
  carouselOpenInNewTabEnabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const store = useStore();
const sponsoredItemTop = computed(() => store.getters['sponsoredItemTopStore/getSponsoredItemTop']);
const productSMData = ref({});
const sponsoredItemTopRef = ref(null);
const isSimplificationOnEnabled = props.isSimplificationOn && isSimplificationOnExperimentEnabled();
const simplificationWithV1 = isSimplificationWithV1ExpEnabled();
const simplificationNonBoldPercentageExp = isSimplificationNonBoldPercentageExpEnabled();
const simplificationRemoveSaleExp = isSimplificationRemoveSaleExpEnabled();
const overridePriceSimplification = isSimplificationOnEnabled;
const isOpenInNewTabEnabled = props.carouselOpenInNewTabEnabled || false;

store.dispatch('sponsoredItemTopStore/setSponsoredItemTopRef', sponsoredItemTopRef);
watch(sponsoredItemTop, (newValue) => {
  /* istanbul ignore next */
  if (newValue.product) {
    productSMData.value = newValue.product?.meta?.productSMData;
    newValue.product = transformer(newValue);
    analyticsUtil.sponsoredItemTopLoadEvent(
      '#sponsored-item-top-container',
      productSMData.value,
    );
  }
});
onMounted(() => {
  /* istanbul ignore next */
  if (sponsoredItemTop.value) {
    productSMData.value = sponsoredItemTop.value.product?.meta?.productSMData;
    analyticsUtil.sponsoredItemTopLoadEvent(
      '#sponsored-item-top-container',
      productSMData.value,
    );
  }
});
</script>

<style lang="scss">
@import "~settingSCSS";
#sponsored-item-top-container:empty {
    margin: 0;
    padding: 0;
    background: transparent;
}
#sponsored-item-top-container {
    margin-top: 2rem;
    padding: 1.5rem;
    background: $background-color;
    .horizontal-alignment {
        .product-description {
            max-width: rem-calc(200px);
            .description-spacing {
                div {
                    &:nth-child(2) {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                    }
                }
            }
            .pricing-and-reviewlet:not(:has(.reviewlet-spacing)) {
                .pricing {
                    margin-top: rem-calc(12px);
                }
            }
            .pricing-and-reviewlet:has(.reviewlet-spacing) {
                .pricing {
                    margin-top: 0;
                }
            }
        }
    }
}
</style>
